export const LoaderDiv = () => {
	const styles = {
		loaderContainer: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			position: "absolute" as const,
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
		},
		loader: {
			width: "50px",
			aspectRatio: 1,
			"--_c": "no-repeat radial-gradient(farthest-side, #034796 92%, #0000)",
			background:
				"var(--_c) top, var(--_c) left, var(--_c) right, var(--_c) bottom",
			backgroundSize: "12px 12px",
			animation: "l7 1s infinite",
		},
	};

	return (
		<div style={styles.loaderContainer}>
			<div style={styles.loader}></div>
		</div>
	);
};
